import React from "react";
import logo from "../assets/logo.png";
import { Link, NavLink } from "react-router-dom";
import { useAccount, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";

const Header = () => {
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address } = useAccount();
  const { open } = useWeb3Modal();
  return (
    <div className="fixed top-0 left-0 mx-auto right-0 w-full z-[11] border-b border-white/10 bg-[#06130f]/88 backdrop-blur">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between gap-4 py-4">
          <Link to="/" className="flex items-center ">
            <img src={logo} className="h-[38px] lg:h-[54px]" alt="" />
            <div className="text-[18px] font-[800] text-[#58df88] lg:text-[20px]">
              HopePepe
            </div>
          </Link>
          <div className="hidden items-center gap-4 sm:flex">
            <NavLink
              to="/"
              className="text-[#fff] hover:text-[#58df88] text-[14px] lg:text-[16px] font-[600]"
            >
              Transition
            </NavLink>
            <a
              href="/#holder-access"
              className="text-[#fff] hover:text-[#58df88] text-[14px] lg:text-[16px] font-[600]"
            >
              Holder access
            </a>
            <NavLink
              to="/trade"
              className="text-[#fff] hover:text-[#58df88] text-[14px] lg:text-[16px] font-[600]"
            >
              Legacy DEX
            </NavLink>
          </div>
          <button
            type="button"
            className="px-[12px] lg:px-[22px] h-[44px] bg-[#58df88] rounded-[8px] flex items-center justify-center text-[#041e0e] text-[14px] font-[800]"
            onClick={() =>
              address
                ? chain?.id == chains[0]?.id
                  ? open()
                  : switchNetwork?.(chains[0]?.id)
                : open()
            }
          >
            {address ? (
              chain?.id == chains[0]?.id  ? (
                address ? (
                  <>
                    {`${address?.substring(0, 6)}...${address?.substring(
                      address.length - 4
                    )}`}
                  </>
                ) : (
                  <>Connect Wallet</>
                )
              ) : (
                "Switch network"
              )
            ) : (
              <>Connect Wallet</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
